import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Qualys extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M21.862,3.512S18.562,0,12,0h0C5.435,0,2.138,3.512,2.138,3.512A46.307,46.307,0,0,0,2,11.345C2.365,19.251,12,24,12,24s9.635-4.749,10-12.655A46.307,46.307,0,0,0,21.862,3.512ZM16.6,16.63a8.664,8.664,0,0,1-2.968-.76c1.438-.918,3.3-2.7,3.3-4.874A4.938,4.938,0,0,0,12,6.065a5.006,5.006,0,0,0-4.927,5.07c0,2.332,1.236,4.163,3.672,5.441a20.443,20.443,0,0,0,6.485,1.772,8.565,8.565,0,0,1-2.184,2.046,15.225,15.225,0,0,1-7.458-3.1A8.146,8.146,0,0,1,4.634,11v-.049A7.366,7.366,0,0,1,19.366,11,7.118,7.118,0,0,1,16.6,16.63Z" />
      </svg>
    );
  }
}

export default Qualys;
